import React from 'react';
import { motion } from 'framer-motion';
export function ForWhoSection() {
  return <section className="py-14 px-6 bg-white relative" data-id="element-68">
      <div className="max-w-5xl mx-auto" data-id="element-69">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-70">
          {/* Es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-cream p-6 md:p-8 rounded-2xl border-2 border-green-600/20 shadow-lg" data-id="element-71">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3 font-serif" data-id="element-72">
              Es para ti solo si...
            </h3>
            <ul className="space-y-3" data-id="element-73">
              {['Llevas más de un año esperando que él se decida.', 'Te da miedo hablar del futuro por no parecer "intensa".', 'Sabes que vales, pero te has perdido complaciendo.', 'Quieres claridad, no manipulación.', 'Estás lista para tomar una decisión con dignidad.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700 text-[14px]" data-id="element-74">
                  <span className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-75">✓</span>
                  <span className="leading-relaxed" data-id="element-76">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-blush/50 p-6 md:p-8 rounded-2xl border-2 border-burgundy/20 shadow-lg" data-id="element-77">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3 font-serif" data-id="element-78">
              <span className="text-xl" data-id="element-79">❌</span> No es para ti si...
            </h3>
            <ul className="space-y-3" data-id="element-80">
              {['Buscas trucos para manipular a alguien.', 'Prefieres vivir en la comodidad de la incertidumbre.', 'No estás dispuesta a trabajar en ti misma.', 'Crees que el amor es suficiente sin acción.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700 text-[14px]" data-id="element-81">
                  <span className="text-burgundy mt-0.5 flex-shrink-0" data-id="element-82">✕</span>
                  <span className="leading-relaxed" data-id="element-83">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}